<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [showHeader]="false"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="true"
    position="bottom"
    styleClass="pwa-install-dialog"
    [breakpoints]="{ '640px': '94vw' }"
    [style]="{ width: '26rem', margin: '0 0 1.25rem' }"
>
    <div class="pwa-install">
        <button type="button" class="pwa-install__close" (click)="dismiss()" aria-label="Cerrar">
            <i class="pi pi-times"></i>
        </button>

        <div class="pwa-install__header">
            <div class="pwa-install__badge">
                <img src="assets/images/osafety-icon.png" alt="OSafety" />
            </div>
            <div class="pwa-install__heading">
                <h3>Instala OSafety en tu inicio</h3>
                <span class="pwa-install__eyebrow">ACCESO RÁPIDO · PWA</span>
            </div>
        </div>

        <div class="pwa-install__benefits">
            <div class="pwa-install__benefit">
                <div class="pwa-install__benefit-icon">
                    <i class="pi pi-bolt"></i>
                </div>
                <span>Un toque</span>
            </div>
            <div class="pwa-install__benefit">
                <div class="pwa-install__benefit-icon">
                    <i class="pi pi-wifi"></i>
                </div>
                <span>Sin conexión</span>
            </div>
            <div class="pwa-install__benefit">
                <div class="pwa-install__benefit-icon">
                    <i class="pi pi-shield"></i>
                </div>
                <span>Sin instalar nada</span>
            </div>
        </div>

        <button type="button" class="pwa-install__cta" (click)="install()">
            <i class="pi pi-download"></i>
            Añadir a mi celular
        </button>

        <button type="button" class="pwa-install__later" (click)="dismiss()">
            Quizás más tarde
        </button>
    </div>
</p-dialog>
